import React from 'react';
import { formatCurrency } from 'utils';
import { grey } from '@mui/material/colors';
import { LocalOffer } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { CircularProgress, Link, Paper, Stack, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';

import { InventoryOptionMatch } from '../../types';

interface Props {
  options: InventoryOptionMatch[];
  loading?: boolean;
}

export const EquipmentOptionsCard = ({ options, loading = false }: Props) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1 }}>
      <Stack direction="row" alignItems="center" gap={1} mb={1}>
        <LocalOffer fontSize="small" color="action" />
        <Typography variant="subtitle1" fontWeight={600} sx={{ textTransform: 'none' }}>
          Options
        </Typography>
      </Stack>

      {loading && options.length === 0 ? (
        <Stack alignItems="center" py={2}>
          <CircularProgress size={20} />
        </Stack>
      ) : options.length > 0 ? (
        <Table size="small">
          <TableBody>
            {options.map(option => (
              <TableRow key={option.inventoryOptionId} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                <TableCell sx={{ border: 'none', pl: 0, py: 0.75, width: '55%' }}>
                  <Link
                    component={RouterLink}
                    to={`/inventory/options/${option.inventoryOptionId}`}
                    target="_blank"
                    rel="noopener"
                    underline="hover"
                    variant="body2"
                    fontWeight={500}
                  >
                    {option.name}
                  </Link>
                  <Typography variant="caption" color="textSecondary" display="block">
                    {option.code}
                  </Typography>
                </TableCell>
                <TableCell sx={{ color: grey[800], border: 'none', py: 0.75, textAlign: 'right' }}>
                  {formatCurrency(option.cost, true)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography variant="body2" color="textSecondary">
          No options available for this equipment.
        </Typography>
      )}
    </Paper>
  );
};
